import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Dati } from '../model/dati';
import { Regioni } from '../model/regioni';
import { Province } from '../model/province';


// definisco tre costanti
const API = 'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-andamento-nazionale.json';
const APIREG = 'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-regioni-latest.json';
const APIPROV = 'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-province-latest.json';
const APIREGall = 'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-regioni.json';
const APIPROVall = 'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-province.json';

@Injectable({
  providedIn: 'root'
})
export class DatiService {
  // definisco l'oggetto dati di tipo Dati
  dati: Dati[];

  //implemento HttpClient per potermi collegare a dati online
  constructor(private http: HttpClient) { }
  // Metodo che mi restituisce i dati nazionali
  getDati(): Observable<Dati[]> {
    return this.http.get<Dati[]>(API);
  }

  // Metodo che mi restituisce i dati regionali
  getDatiReg(): Observable<Regioni[]> {
    return this.http.get<Regioni[]>(APIREG);
  }

  // Metodo che mi restituisce i dati provinciali
  getDatiProv(): Observable<Province[]> {
    return this.http.get<Province[]>(APIPROV);
  }

  // Metodo che mi restituisce i dettagli delle regioni
  detailReg(id): Observable<Regioni[]> {
    return this.http.get<Regioni[]>(`${APIREGall}?id=${id}`);
  }

    // Metodo che mi restituisce i dettagli delle province
    detailProv(): Observable<Province[]> {
      return this.http.get<Province[]>(`${APIPROVall}`);
    }
  
}
